import { StoryblokImage } from "@wojo/storyblok";
import cn from "clsx";
import { useId } from "react";
import styles from "./InfoCard.module.scss";

export type InfoCardProps = React.PropsWithChildren<{
    graphic?: {
        lightModeSrc?: string;
        darkModeSrc?: string;
        size?:
            | {
                  height?: number;
                  width: number;
              }
            | {
                  height: number;
                  width?: number;
              };
    };
    heading?: React.ReactNode;
}>;

export const InfoCard: React.FC<InfoCardProps> = ({
    children,
    graphic,
    heading,
}) => {
    const headingId = useId();
    return (
        <section
            aria-labelledby={heading ? headingId : undefined}
            className={styles.wrapper}
        >
            {graphic?.lightModeSrc && (
                <>
                    <StoryblokImage
                        mobile={{
                            asset: {
                                filename: graphic.lightModeSrc,
                            },
                            size: graphic.size,
                        }}
                        className={cn(styles.image, styles["image--light"])}
                    />
                    {graphic.darkModeSrc && (
                        <StoryblokImage
                            mobile={{
                                asset: {
                                    filename: graphic.darkModeSrc,
                                },
                                size: graphic.size,
                            }}
                            className={cn(styles.image, styles["image--dark"])}
                        />
                    )}
                </>
            )}
            {heading && <div id={headingId}>{heading}</div>}
            {children}
        </section>
    );
};
